
import device from 'bits/device'
import fetchElectronBridge, { URLTarget } from 'bits/electron_bridge'
import { getSearchParams, navigateTo, transformUrl } from 'bits/location'
import { Component, Prop, Vue } from 'bits/vue'
import AuthLoginThirdPartyButton from 'vuecomponents/AuthLoginThirdPartyButton.vue'
import { LoginMethod } from 'vuexstore/landside'

export enum AuthLoginThirdPartyGroupButtonsType {
  Continue = 'Continue',
  LogIn = 'Log in',
  SignUp = 'Sign up',
}

const ButtonType = AuthLoginThirdPartyGroupButtonsType

@Component({
  components: {
    AuthLoginThirdPartyButton,
  },
})
export default class AuthLoginThirdPartyGroupButtons extends Vue {
  @Prop({ default: () => {} }) loginMethods!: Record<string, LoginMethod>
  @Prop({ default: AuthLoginThirdPartyGroupButtonsType.Continue }) type!: AuthLoginThirdPartyGroupButtonsType

  navigateTo = navigateTo

  get isApple(): boolean {
    return device.mac || device.ios
  }

  get appleText(): string {
    return {
      [ButtonType.Continue]: this.__('Continue with Apple'),
      [ButtonType.LogIn]: this.__('Log in with Apple'),
      [ButtonType.SignUp]: this.__('Sign up with Apple'),
    }[this.type]
  }

  get googleText(): string {
    return {
      [ButtonType.Continue]: this.__('Continue with Google'),
      [ButtonType.LogIn]: this.__('Log in with Google'),
      [ButtonType.SignUp]: this.__('Sign up with Google'),
    }[this.type]
  }

  get microsoftText(): string {
    return {
      [ButtonType.Continue]: this.__('Continue with Microsoft'),
      [ButtonType.LogIn]: this.__('Log in with Microsoft'),
      [ButtonType.SignUp]: this.__('Sign up with Microsoft'),
    }[this.type]
  }

  get skoletubeText(): string {
    return {
      [ButtonType.Continue]: this.__('Continue with Skoletube'),
      [ButtonType.LogIn]: this.__('Log in with Skoletube'),
      [ButtonType.SignUp]: this.__('Sign up with Skoletube'),
    }[this.type]
  }

  get classlinkText(): string {
    return {
      [ButtonType.Continue]: this.__('Continue with ClassLink'),
      [ButtonType.LogIn]: this.__('Log in with ClassLink'),
      [ButtonType.SignUp]: this.__('Sign up with ClassLink'),
    }[this.type]
  }

  handleClick(url: string): void {
    const electronApp = fetchElectronBridge()
    const referralCode = getSearchParams().referral_code
    const oauthUrl = referralCode
      ? transformUrl(url, {
          searchParams: {
            referralCode,
          },
        })
      : url

    if (electronApp.openThirdPartyAuth) {
      return electronApp.openThirdPartyAuth(oauthUrl, URLTarget.Internal)
    }

    this.navigateTo(oauthUrl)
  }
}
